module.exports = __webpack_public_path__ + "img/deep.aa058a58.jpg";